import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';

export const Wrapper = styled.div`
    display: block;
    width: 100%;
    position: relative;
    @media screen and (max-width: 859px) {
        padding-bottom: ${p => p.isHorizontal ? '0' : '50%'};
    }
    @media (max-height: 600px) and (max-width: 530px) {
        padding-bottom: ${p => p.isHorizontal ? '0' : '55%'};
    }
`;

export const Block = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100vh;
`;

export const Text = styled.div`
    display: block;
    font-size: 32px;
    line-height: 1.33;
    font-family: ${FONTS.regular};
    width: 530px;
    p {
        margin: 15px 0;
    }
    a {
        color: ${COLORS.lightBlue};
    }
`;

export const Image = styled.img`
    display: none;
    width: 648px;
`;

export const FixedBlockImages = styled.div`
    display: ${p => p.length === 1 ? 'none' : 'block'};
    position: ${p => p.fixed ? 'fixed' : 'absolute'};
    top: ${p => p.top ? '0' : 'auto'};
    bottom: ${p => p.top ? 'auto' : '0'};
    right: 0;
    left: auto;
    width: ${p => p.fixed ? 'calc(100% - 125px)' : '100%'};
    height: 100vh;
    align-items: center;
    pointer-events: none;
    @media (max-width: 929px) {
        height: 100%;
    }
    @media screen and (max-width: 859px) {
        width: 100%;
        display: ${p => p.isHorizontal ? 'none' : 'block'};
    }
`;

export const ContainerFixImage = styled(GridContainer)`
    @media (max-width: 929px) {
        height: 100%;
    }
`;

export const Images = styled.div`
    display: block;
    position: relative;
    width: 648px;
    height: 100vh;
    margin-left: auto;
    @media (max-width: 1599px) {
        width: 499px;
    }
    @media (max-width: 1279px) {
        width: 374px;
    }
    @media (max-width: 997px) {
        width: 343px;
    }
    @media (max-width: 929px) {
        height: 100%;
    }
    @media (max-width: 859px) {
        width: 100%;
        &:before {
            display: block;
            content: '';
            position: absolute;
            height: 60px;
            bottom: 0;
            top: auto;
            right: 0;
            left: 0;
            background-color: ${p => p.bgColor ? p.bgColor : 'transparent'};
        }
    }
`;

export const ImageFixed = styled.img`
    display: block;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    opacity: ${p => p.active ? '1' : 0};
    transition: 0.5s;
    @media (max-width: 929px) {
        top: auto;
        bottom: 50px;
    }
`;
